export default __webpack_public_path__ + "static/media/quaternion.f7d3c3e6.png";